import React from 'react';
import {CalendarProvider} from '../context/CalendarProvider';
import AuditContainer from '../container/AuditContainer';

function Audit(props) {
    return (
        <div className="sidebar-bottomcontent-container">
            <div className="sidebar-bottomcontent-container-row">
                <CalendarProvider onLogoutClick={props.onLogoutClick}
                    setSelectedNavItem={props.setSelectedNavItem} isLogout={props.isLogout}
                    setLogoutFalse={props.setLogoutFalse} clearSessionData={props.clearSessionData}>
                        <AuditContainer isLogout={props.isLogout}   
                                        onLogoutClick={props.onLogoutClick}
                                        clearSessionData={props.clearSessionData} 
                                        UserId ={props.UserId} />
                </CalendarProvider> 
            </div>
        </div>
    );
}

export default Audit;